module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/1-dfcf0dee8f3e4db8754ca4e0ca90945d.png";